/**
 * Phone numbers are stored in E.164 international format (e.g. +263772123456) everywhere
 * in the system — so they work for WhatsApp/SMS and match at member sign-in. These helpers
 * are the single source of truth for that rule across every form.
 */

const E164 = /^\+[1-9]\d{7,14}$/;

/** Strip human separators, keeping a leading + and digits. */
export function normalizeIntlPhone(value: string): string {
  return value.replace(/[\s().-]/g, '');
}

/** True if the value is a valid E.164 number (ignoring spaces/dashes the user typed). */
export function isIntlPhone(value: string): boolean {
  return E164.test(normalizeIntlPhone(value));
}

export const INTL_PHONE_PLACEHOLDER = '+263 77 123 4567';
export const INTL_PHONE_HELP = 'Use international format, e.g. +263772123456';
